import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { QuoteDiscounts, QuotePayableData } from '@lx/quote-tool/shared/types';
import { TransferServiceType } from '@lx/shared/data-access/products';
import { Amount } from '@lx/shared/data-access/types';

export interface QuoteState {
  displayCurrency?: string;
  destinationCurrency?: string;
  singleCurrencyMode?: boolean;
  grandTotal?: LimitedCurrencyAmount[];
  productTotal?: LimitedCurrencyAmount[];
  discountTotal?: LimitedCurrencyAmount[];
  discountTotalAsPercentage?: string;
  discounts?: QuoteDiscounts[];
  payableData?: QuotePayableData;
  course?: QuoteOutputCourse;
  accommodation?: QuoteOutputProduct;
  transfers?: QuoteOutputTransfer[];
  feesAndSupplements?: QuoteOutputProduct[];
  professionalImmersionExperience?: QuoteOutputProduct;
  insurance?: QuoteOutputProduct;
  premiumResidence?: QuoteOutputProduct;
  privateLessons?: QuoteOutputProduct;
  unaccompaniedMinorServices?: QuoteOutputProduct[];
  premiumActivities?: QuoteOutputProduct[];
  quoteId?: string;
}

export interface QuoteOutputProduct {
  code?: string;
  name?: string;
  price?: Amount[];
  endPrice?: LimitedCurrencyAmount[];
  discount?: LimitedCurrencyAmount[];
  discountTotalAsPercentage?: string;
  units?: number;
  row?: number;
}

export interface QuoteOutputCourse extends QuoteOutputProduct {
  startDate?: string;
  endDate?: string;
}

export interface QuoteOutputTransfer extends QuoteOutputProduct {
  transferServiceType?: TransferServiceType;
}
